import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedundantProteome = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 50 65",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M33.3 18.7H52L33.3 0v18.7ZM7.5 45.2 9 43.7l10.6 10.5-1.5 1.5h-6.2l-4.4-4.4v-6.1Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M29.1 0v22.9H52v43.7H0V0h29.1Zm1 30.3 6.2 6.1c.2.3.3.5.3.9v8.6c0 .4-.1.6-.3.9L30 52.9c-.2.2-.5.3-.8.3H28l3.6 3.6-4.7 4.7-4.4-4.3-2.4 2.4c-.2.2-.5.3-.8.3h-8.7c-.3 0-.6-.1-.8-.3l-6.1-6.2c-.2-.2-.4-.5-.4-.8v-8.7c0-.3.2-.6.4-.8L6 40.7 3.3 38 8 33.3l3.4 3.3h2.1l-.2.7v1.3l2.3 2.2H18l4.3 4.4v2.5l4.2 4.2v-8c0-.3-.1-.6-.3-.8L20 36.9c-.2-.2-.5-.3-.8-.3h-5.8l.1-.2 6.2-6.1c.2-.2.5-.3.8-.3h8.7c.3 0 .6 0 .8.3Z",
		fill: "currentColor"
	})]
});
export default SvgRedundantProteome;
